import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { environment as env } from '../../environments/environment';
import {
  Grid,
  TextField,
  Checkbox,
  Button,
  makeStyles,
  FormControl,
  FormGroup,
  IconButton,
  Input,
  InputLabel,
  InputAdornment,
} from '@material-ui/core';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import Services from '../../Services';
import { Imports } from '../../Imports';
import Snackbar from '../../Components/Snackbar';
import { helpers } from '../../helpers';
import { paths } from '../Applicant/Application/path';
import { useDispatch } from 'react-redux';
import { setAccessTokens } from '../../redux/features/utils.slice';


const {
  users,
  hr,
  Storage,
} = Services;

const {
  showSnackBar,
} = helpers;

const Login = () => {

  const history = useHistory();

  const dispatch = useDispatch()
  const storage = new Storage();

  const [isLoggingIn, setIsLoggingIn] = useState(false);


  const [values, setValues] = useState({
    amount: '',
    password: '',
    weight: '',
    weightRange: '',
    showPassword: false,
  });


  useEffect(() => {
    let user = JSON.parse(localStorage.getItem('user_profile')) || null;
    let token = localStorage.getItem('access_jwt') || null
    localStorage.setItem('pastScreen', "Applicant")
    localStorage.setItem('isEmployee', JSON.stringify(false))
    if (token) {
      if (user) {
        var { ApplicantStatusId } = user;
        history.push(paths[ApplicantStatusId]);
      }
    }
  }, [])


  Object.assign(window, { gt: hr.getAllApplicantsByID });

  const loginUser = async () => {

    let pastScreen = localStorage.getItem('pastScreen')
    let isEmployee = localStorage.getItem('isEmployee')
    if (!pastScreen && !isEmployee) {
      localStorage.setItem('pastScreen', "Applicant")
      localStorage.setItem('isEmployee', JSON.stringify(false))
    }




    try {
      setIsLoggingIn(true);
      const { password, email } = values;

      const payload = { password, email };

      if (!email) {
        setIsLoggingIn(false);
        return showSnackBar('Please enter email address');
      }

      if (!password) {
        setIsLoggingIn(false);
        return showSnackBar('Please enter password');
      }


      const response = await users.login(payload);

      let { data, token } = response

      console.log(response);

      const {
        id: employeeId
      } = data;

      const [
        applicantPayDetails
      ] = await Promise.all([
        hr.getAllApplicantsByIDApplicantLogin(
          { id: employeeId },
          {
            Authorization: token
          }
        )
      ]);


      storage.set('payDetails', JSON.stringify(applicantPayDetails));
      storage.set('access_jwt', token);
      dispatch(setAccessTokens({ token }))
      storage.set('user_profile', JSON.stringify(data))

      setIsLoggingIn(false);

      const {
        path: pathname,
        params: state,
      } = Imports
        ?.employeeStatuses
        ?.find(
          status => status?.id === data?.ApplicantStatusId
        )

      const stateToPush = state
        ? {
          pathname,
          state,
        }
        : pathname;

      const applicantLoggedInEvent = new CustomEvent('applicant-logged-in', {});

      window.dispatchEvent(applicantLoggedInEvent);

      history.push(stateToPush);

      localStorage.setItem('isEmployee', JSON.stringify(false))
      localStorage.setItem('pastScreen', "Applicant")

    } catch (exc) {
      console.log(exc);
      setIsLoggingIn(false);
      return false;
    }
  };

  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  const divStyles = { display: "flex", alignItems: "center", backgroundColor: "white", paddingRight: "10px", borderRadius: "10px" }


  return (
    <Grid container xs={12}>
      <Grid className="applicantImageBG">
        <Grid className="applicantImage">
        </Grid>
      </Grid>
      <Grid className="LoginFormPlace">
        <Grid className="LoginForm">
          <Grid className="LoginTitle">Applicant Login</Grid>
          <Grid className="FormFields">

            <TextField placeholder="Email / User ID" type="text" onChange={handleChange('email')} />

            <FormControl
              className="LoginPwd">

              <div style={divStyles}>
                <Input
                  placeholder="Password"
                  id="standard-adornment-password"
                  type={values.showPassword ? 'text' : 'password'}
                  style={{ width: "100%" }}
                  value={values.password}
                  onChange={handleChange('password')}
                  onKeyPress={event => {
                    if (event.key === 'Enter') {
                      loginUser()
                    }
                  }}
                />
                {values.showPassword ? <Visibility style={{ cursor: "pointer", backgroundColor: "transparent" }} onClick={handleClickShowPassword} /> : <VisibilityOff style={{ cursor: "pointer", backgroundColor: "transparent" }} onClick={handleClickShowPassword} />}
              </div>
            </FormControl>

            <Grid xs={12} container className="mt16">
              <Grid className="LoginCheckPlace">
                <Checkbox
                  defaultChecked
                  color="primary"
                  inputProps={{ 'aria-label': 'secondary checkbox' }}
                />Remember me
              </Grid>
              <Grid className="LoginForget">
                <Link to="/forgetPassword">Forget Password</Link>
              </Grid>
            </Grid>
            <Grid xs={12} container justify="center" className="mt26">
              <Button className="LoginBtn"
                onClick={loginUser}
                disabled={isLoggingIn}>Login</Button>
              <Snackbar
              ></Snackbar>
            </Grid>
            <Grid xs={12} container justify="center" className="mt20">
              <a href="application" className="ApplicantBtn">Submit Application & Create Account</a>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
export default Login;